import { Controller } from "@hotwired/stimulus"
import PoldrackTextPlugin from "../../vendor/stroop/plugins/jspsych-poldrack-text.js";
import { post } from "@rails/request.js"
import { stims, assessPerformance, enter_fullscreen, instruction_node, start_practice_block, fixation_block, practice_block, attention_node, start_test_block, test_block, post_task_block, close_page_block } from "./blocks.js";

import JsPsychManager from "./js_psych_manager";

export default class extends Controller {
  static targets = ["experiment"];
  static values = {
    practiceLen: Number,
    testLen: Number
  }

  stroop_experiment = []

  connect() {
    console.log("Stroop controller connected!");

    this.jsPsychManager = new JsPsychManager();
    this.jsPsych = this.jsPsychManager.getInstance();

    // console.log("jsPsych instance created:", this.jsPsych);

    console.log(this.practiceLenValue);
    console.log(this.testLenValue);

    var practice_len = this.practiceLenValue
    var practice_stims = this.jsPsych.randomization.repeat(stims, practice_len / 12, true)
    var test_len = this.testLenValue
    var test_stims = this.jsPsych.randomization.repeat(stims, test_len / 12, true)

    // console.log("Practice stimuli:", practice_stims);

    this.stroop_experiment.push(enter_fullscreen)
    this.stroop_experiment.push(instruction_node)
    this.stroop_experiment.push(start_practice_block)

    for (var i = 0; i < practice_len; i++) {
      this.stroop_experiment.push(fixation_block(this.jsPsych))
      this.stroop_experiment.push(practice_block(this.jsPsych, practice_stims, i))
    }

    this.stroop_experiment.push(attention_node)
    this.stroop_experiment.push(start_test_block)

    for (i = 0; i < test_len; i++) {
      this.stroop_experiment.push(fixation_block(this.jsPsych))
      
      this.stroop_experiment.push(test_block(this.jsPsych, test_stims, i))
    }

    this.stroop_experiment.push(attention_node)
    this.stroop_experiment.push(post_task_block)
    this.stroop_experiment.push(this.end_block(this.jsPsych))
    this.stroop_experiment.push(close_page_block)
    
    // jsPsych.run(stroop_experiment, this.experimentTarget)
    this.jsPsych.run(this.stroop_experiment, this.experimentTarget)

  }

  // TODO: dont know if all of this needs to be here
  end_block(jsPsych) {
    return {
      type: PoldrackTextPlugin,
      data: {
        trial_id: "end",
        exp_id: 'stroop'
      },
      trial_duration: 180000,
      text: '<div class = centerbox><p class = center-block-text>Merci d\'avoir complété cette tâche !</p><p class = center-block-text>Appuyez sur <strong>Entrée</strong> pour continuer et enregistrer les données.</p></div>',
      cont_key: [13],
      timing_post_trial: 0,
      on_finish: function(data){
  
        assessPerformance(jsPsych)
  
        var dataJSON = jsPsych.data.get().json();
  
        const parsedData = JSON.parse(dataJSON);  // Convertir en objet
  
        const fullData = JSON.stringify(parsedData.map(trial => ({
          success: trial.success || "",
          rt: trial.rt || "",
          trial_type: trial.trial_type || "",
          trial_index: trial.trial_index || "",
          plugin_version: trial.plugin_version || "",
          time_elapsed: trial.time_elapsed || "",
          exp_id: trial.exp_id || "",
          full_screen: trial.full_screen || "",
          focus_shifts: trial.focus_shifts || "",
          trial_id: trial.trial_id || "",
          text: trial.text || "",
          key_press: trial.key_press || "",
          block_duration: trial.block_duration || "",
          timing_post_trial: trial.timing_post_trial || "",
          view_history: trial.view_history || "",
          stimulus: trial.stimulus || "",
          response: trial.response || "",
          exp_stage: trial.exp_stage || "",
          condition: trial.condition || "",
          stim_color: trial.stim_color || "",
          stim_word: trial.stim_word || "",
          correct_response: trial.correct_response || "",
          correct: trial.correct || "",
          possible_responses: trial.possible_responses || "",
          stim_duration: trial.stim_duration || "",
          feedback_duration: trial.feedback_duration || "",
          credit_var: trial.credit_var || ""
        })));
  
        // Get the experience configuration ID
        const urlParams = new URLSearchParams(window.location.search);
        const expe_config_id = urlParams.get('experience_configuration_id');
  
        const formData = new FormData();
        formData.append("data", fullData);
        formData.append("experience_configuration_id", expe_config_id);
  
        
        post('save_psycho_test_data', {
          body: formData,
          responseKind: 'json'
        }).then(response => {
          if(response.statusCode == 200) {
            // success
          } else {
            // local save
            jsPsych.data.get().localSave('csv', 'stroop_results.csv');
          }
        }).catch(error => {
          // console.error("Error:", error);
          // gestion de l’erreur
          
        })
      }
    }
  };

  

  
}
